// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1plks","consentsList":"PatientConsents_consentsList__2KwfK","consentsListEmpty":"PatientConsents_consentsListEmpty__1cbMM"};